import React, { Suspense, lazy } from 'react';
import './AboutUs.css';
import { getStoredData } from "../../json/fetchData.js";

// Lazy load the components
const ContentModel = lazy(() => import("../../components/ContentModel/ContentModel.js"));
const CompanyProfile = lazy(() => import('../../components/CompanyProfile/CompanyProfile.js'));
const AllIntroTemplate = lazy(() => import("../../components/AllIntroTemplate/AllIntroTemplate.js"));

const AboutUs = () => {
  const totalData = getStoredData();
  const data = totalData ? totalData["3"] : {};

  return (
    <div>
      <Suspense fallback={<div>Loading...</div>}>
        <AllIntroTemplate 
          image={data.Image} 
          title={data.Title} 
          page={totalData ? totalData["0"] : {}}
        />
      </Suspense>

      <Suspense fallback={<div>Loading content...</div>}>
        <ContentModel data={totalData ? totalData["3"] : {}}/>
      </Suspense>

      <Suspense fallback={<div>Loading company profile...</div>}>
        <CompanyProfile data={data.CompanyProfile} title={data.CompanyProfileHeader}/>
      </Suspense>
    </div>
  );
};

export default AboutUs;
